import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Grid } from "@mui/material";
import { styled, lighten } from "@mui/material/styles";
import { COLORS } from "src/_globalStore/redux/reducers/Theme/themeConstants";

export const TableContainer = styled(Grid)(({ theme }) => ({
  "& .highlighted": {
    // border: `2px solid ${theme.palette.error.light}`,
    borderRadius: "3px",
    maxWidth: "calc(100% - 4px)",
    backgroundColor: lighten(COLORS.yellow_gradients.yellow, 0.2),
  },
}));
export const EmployeeNameContainer = styled(Grid)({
  "&:hover": {
    cursor: "pointer",
  },
});

export const SignatureContainer = styled("img", {
  shouldForwardProp: (prop) => prop !== "height",
})<{ height?: number }>(
  {
    width: "100px",
    height: "40px",
    borderRadius: "15px",
    objectFit: "contain",
    alignSelf: "center",
    marginRight: 5,
  },
  ({ height }) => ({
    ...(height && { height: `${height}px` }),
  })
);

export const SignOffDate = styled(Grid)(({ theme }) => ({
  fontWeight: 700,
  color: theme.palette.text.primary,
  fontSize: "0.6em",
  textAlign: "start",
  marginTop: "1px",
  paddingTop: "0px",
}));

export const SignOffBlock = styled(Grid)({
  fontWeight: 700,
  fontSize: "1rem",
  textAlign: "start",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
});

export const FilesContainer = styled(Grid)({
  display: "flex",
  flex: "1",
  gap: "0",
});

export const StyledFontAwesomeIcon = styled(FontAwesomeIcon, {
  shouldForwardProp: (prop) => prop !== "color",
})<{ color?: string }>(({ theme, color }) => ({
  color: color ?? theme.palette.primary.main,
}));
